<div class="modal-header container-md" id="modal-header">
    <div class="col-4"></div>
    <div class="col-4">
      <img id="modal-memorabid-logo" src="/assets/img/memorabid-logo-white.svg" alt="MEMORABID">
    </div>
    <div class="col-4"></div>
</div>
<div class="modal-body">
    <div class="d-flex justify-content-center mt-3">
        <label class="dialog-centered text-muted">{{'IDS_DIRECT_OFFER_ALREADY_MADE' | translate}}</label>
    </div>
    <div class="d-flex justify-content-center my-3">
        <button class="admin-new text-uppercase fw-bold px-3" type="button" (click)="activeModal.close()">{{'IDS_OK' | translate}}</button>
    </div>
</div>
